/**
 * @generated SignedSource<<fe18fde460d43ff5662c5eb76aac2f59>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MarketingEmailStatus = "DRAFT" | "PARTIALLY_SENT" | "SENDING" | "SENT" | "%future added value";
export type LaunchMarketingEmailInput = {
  id: string;
};
export type LaunchMarketingEmailDialogMutation$variables = {
  input: LaunchMarketingEmailInput;
};
export type LaunchMarketingEmailDialogMutation$data = {
  readonly launchMarketingEmail: {
    readonly id: string;
    readonly sentAt: any | null | undefined;
    readonly status: MarketingEmailStatus;
  };
};
export type LaunchMarketingEmailDialogMutation = {
  response: LaunchMarketingEmailDialogMutation$data;
  variables: LaunchMarketingEmailDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MarketingEmail",
    "kind": "LinkedField",
    "name": "launchMarketingEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sentAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LaunchMarketingEmailDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LaunchMarketingEmailDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f97ef42cfc058b89ad15a5aef152639f",
    "id": null,
    "metadata": {},
    "name": "LaunchMarketingEmailDialogMutation",
    "operationKind": "mutation",
    "text": "mutation LaunchMarketingEmailDialogMutation(\n  $input: LaunchMarketingEmailInput!\n) {\n  launchMarketingEmail(input: $input) {\n    id\n    status\n    sentAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "dce467e8d5bb6ff8daf4b533137a904c";

export default node;
